var fowtr_module_utilities = (function (fowtr_module_utilities) {

    // fowtr_module_utilities.disableFancyStuff = null;

    fowtr_module_utilities.init = function(){
      
    };

    
    fowtr_module_utilities.isMobile = (function(a){return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4));})(navigator.userAgent||navigator.vendor||window.opera);

    if(fowtr_module_utilities.isMobile){
      $('#fowtr-wrapper').addClass('ismobile');
    }


    fowtr_module_utilities.loadSVGasXML  = function(SVGFile,callback){
      if(fowtr_module_utilities.disableFancyStuff) return;
        // var SVGFile="http://upload.wikimedia.org/wikipedia/en/4/4a/Commons-logo.svg"
        var loadXML = new XMLHttpRequest;
        function handler(){
            if(loadXML.readyState == 4 &&loadXML.status == 200){
                   // svgDiv.innerHTML=loadXML.responseText;
                   // mySvgValue.value= svgDiv.innerHTML;
                   callback(loadXML.responseText);
            }
        }
        if (loadXML != null){
            loadXML.open("GET", SVGFile, true);
            loadXML.onreadystatechange = handler;
            loadXML.send();
        }
    }


    // this version a little better as it replaces an img tag with svg as src
    // so the img is captured in the loadImages function.
    fowtr_module_utilities.inlineSvg  = function(element,callback){
      if(fowtr_module_utilities.disableFancyStuff) return;
        var SVGFile = $(element).attr('src');
        if(SVGFile!==undefined){
          var loadXML = new XMLHttpRequest;
          function handler(){
              if(loadXML.readyState == 4 &&loadXML.status == 200){
                 var svg = $(loadXML.responseText);
                 element.replaceWith(svg);
                 callback(svg);
              }
          }
          if (loadXML != null){
              loadXML.open("GET", SVGFile, true);
              loadXML.onreadystatechange = handler;
              loadXML.send();
          }
        } else {
          console.warn('error loading SVGFile',SVGFile);
        }
    }



    fowtr_module_utilities.getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };
    // if(fowtr_module_utilities.getUrlParameter('whatever')!==false){
    //   //
    // }


    fowtr_module_utilities.getHeaderHeight = function getUrlParameter(sParam) {
      var headerHeight = 56 + 52 + 50;
      if($('#fowtr-wrapper').hasClass('fowtr-fullscreen')) {
        headerHeight = 50;
      } else {
        if($(window).width()<768){
          headerHeight = 56 + 50;
        }
      }
      return headerHeight;
    };



    fowtr_module_utilities.debounce = function(func, wait, immediate) {
      var timeout;
      return function() {
        var context = this,
          args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    };






    fowtr_module_utilities.getArticleClosestToCenter = function(){
      var mid = $(window).height() / 2;
      var scrollTop = $(document).scrollTop();
      mid = mid+scrollTop;
      // console.log('mid',mid);
      var closest = 999999;
      var closestArticle = 0;
      $.each($('#fowtr-wrapper article > div'), function(index, val) {
        if(typeof $(this).attr('id') !== 'undefined'){
          var articleId = $(this).attr('id');
          if(articleId.indexOf('fowtr-article')!=-1){
            articleId = articleId.replace('fowtr-article','');
            var rect = $(this)[0].getBoundingClientRect();
            var elMid = (rect.top + ((rect.bottom - rect.top)/2)) + scrollTop;
            // console.log('article'+articleId+' elMid',elMid);
            var dist = Math.abs(elMid - mid);
            // console.log('dist',dist);
            if(dist < closest) {
              closest = dist;
              closestArticle = articleId;
            }
          }
        }
      });
      return closestArticle;
    };









    fowtr_module_utilities.keys = {37: 1, 38: 1, 39: 1, 40: 1};

    fowtr_module_utilities.preventDefaultForScrollKeys  = function(e){
    // function preventDefaultForScrollKeys(e) {
      if (fowtr_module_utilities.keys[e.keyCode]) {
        fowtr_module_utilities.preventDefault(e);
        return false;
      }
    }

    fowtr_module_utilities.preventDefault  = function(e){
    // function preventDefault(e) {
      e.preventDefault();
    }

    // modern Chrome requires { passive: false } when adding event
    fowtr_module_utilities.supportsPassive = false;
    try {
      window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
        get: function () { fowtr_module_utilities.supportsPassive = true; } 
      }));
    } catch(e) {}

    fowtr_module_utilities.wheelOpt = fowtr_module_utilities.supportsPassive ? { passive: false } : false;
    fowtr_module_utilities.wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

    // call this to Disable
    fowtr_module_utilities.disableScroll  = function(){
    // function disableScroll() {
      // console.log('scrolling disabled');
      window.addEventListener('DOMMouseScroll', fowtr_module_utilities.preventDefault, false); // older FF
      window.addEventListener(fowtr_module_utilities.wheelEvent, fowtr_module_utilities.preventDefault, fowtr_module_utilities.wheelOpt); // modern desktop
      window.addEventListener('touchmove', fowtr_module_utilities.preventDefault, fowtr_module_utilities.wheelOpt); // mobile
      window.addEventListener('keydown', fowtr_module_utilities.preventDefaultForScrollKeys, false);
    }

    // call this to Enable
    fowtr_module_utilities.enableScroll  = function(){
    // function enableScroll() {
      // console.log('scrolling enabled');
      window.removeEventListener('DOMMouseScroll', fowtr_module_utilities.preventDefault, false);
      window.removeEventListener(fowtr_module_utilities.wheelEvent, fowtr_module_utilities.preventDefault, fowtr_module_utilities.wheelOpt); 
      window.removeEventListener('touchmove', fowtr_module_utilities.preventDefault, fowtr_module_utilities.wheelOpt);
      window.removeEventListener('keydown', fowtr_module_utilities.preventDefaultForScrollKeys, false);
    }







    return fowtr_module_utilities;
}(fowtr_module_utilities || {}));
